import { IComponentController } from 'angular';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IMenuDividerClass } from '../../../../../core/services/menu/menu-divider.service';

interface IPageAc0007 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence;
    erdMultiOccurrence: IMultiOccurrence;
    erdMultiOccurrenceOptions: IMultiOccurrenceOptions;
    conMultiOccurrenceOptions: IMultiOccurrenceOptions;
    mntFormulaire: IFormulaire;
    valeursEcran: any;
}
/* @ngInject */
export default function Ac0007Controller(
    $stateParams: any,
    ecranDetails: IEcranDetailsResourcesEntite,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    Menu: IMenuClass,
    MenuItemEcran: IMenuItemEcranClass,
    MenuItemAction: IMenuItemActionClass,
    MenuItemForage: IMenuItemForageClass,
    mc0046Route: IRoute,
    mc1014Route: IRoute,
    ac2000Route: IRoute,
    ac0022Route: IRoute,
    ac0010Route: IRoute,
    MenuDivider: IMenuDividerClass,
) {

    const vm: IPageAc0007 = this;

    const docConsomme = [
        new MenuItemForage(
            'BTN_DOC_CONSOMME',
            (rowData: any) => getForageItem(rowData),
            (rowData: any) => getParamItem(rowData),
            {
                icon: 'exit_to_app',
                iconButton: true
            }
        )
    ];

    vm.valeursEcran = ecranDetails;

    vm.monoOccurrenceOptions = {
        fonctions: {
            boutonDupliquer: false,
            supprime: false,
        },
        actionsMore: new Menu([
            new MenuItemEcran(
                'LBL_IMPUTATION',
                mc0046Route.NAME,
                (data: any) => ({
                    vaeusient: 'ETR',
                    uvicleintref: vm.monoOccurrence.data.etrcleint
                }),
                {
                    fonction: 'BOUIMP',
                    icon: 'view_list',
                    iconButton: false
                }
            ), new MenuItemEcran(
                'LBL_TOLERANCE',
                mc1014Route.NAME,
                () => ({
                    tolcleintref: vm.monoOccurrence.data.etrcleint,
                    vaeustent: 'ETR'
                }),
                {
                    fonction: 'BOUTOL',
                    icon: 'data_usage',
                    iconButton: false,
                    secondaire: true
                }
            ), new MenuItemEcran(
                'LBL_HISTO',
                ac2000Route.NAME,
                () => ({
                    etrcleint: vm.monoOccurrence.data.etrcleint
                }),
                {
                    fonction: 'BOUHIS',
                    icon: 'open_in_new'
                }
            ),
            new MenuItemEcran(
                'LBL_BTN_HISTO_IMP',
                ac0022Route.NAME,
                (data: any) => ({
                    dhicleintref: data.doccleintref,
                    dhityp: 'DOC'
                }),
                {
                    icon: 'launch',
                    iconButton: false,
                    fonction: 'BOUHISIMP'
                }
            )
        ]),
        formulaire: new Formulaire('LBL_BLC_ETR', [
            new FormulaireItem('etccleint', { default: $stateParams.etccleint }),
            new FormulaireItem('tydcleint'),
            new FormulaireItem('aut__etcnumdoc'),
            new FormulaireItem('aut__etcdsc', { largeur: 66.66 }),
            new FormulaireItem('etcnumdocseq'),
            new FormulaireItem('aut__refcodnom'),
            new FormulaireItem('etrflgact'),
            new FormulaireItem('etrdatdeb'),
            new FormulaireItem('etrdatfin'),
            new FormulaireItem('intcleintreq'),
            new FormulaireItem('etrmntetc'),
            new FormulaireItem('taxcleint'),
            new FormulaireItem('etrnumref'),
            new FormulaireItem('etrflgaut')
        ], { largeurDefaut: 33.33 })
    };

    vm.mntFormulaire = new Formulaire('', [
        new FormulaireItem('etrmntcon'),
        new FormulaireItem('etrmntcondoc'),
        new FormulaireItem('etrmntpay')
    ]);

    function getSelectedRow(): any {
        return vm.erdMultiOccurrence?.dataList?.find(r => r?.erdcleint === vm.erdMultiOccurrence.activeRowCleint);
    }

    vm.erdMultiOccurrenceOptions = {
        resourceParamsDynamique: () => ({
            etrcleint: vm.monoOccurrence.data.etrcleint,
            doccleint: vm.monoOccurrence.data.doccleintref,
            edecleint: getSelectedRow()?.edecleint, // nécessaire pour modifier la description d'un article
            erdcleint: getSelectedRow()?.erdcleint,
        }),
        bloc: 'erd',
        fonctions: {
            boutonDupliquer: false,
            supprime: false,
        },
        actionsMoreLigne: new Menu([
            new MenuItemAction(
                'G_LBL_BTN_SUPPRIMER',
                'BOUSUP',
                (rowData: any) => getParamItemSupprime(rowData),
                {
                    icon: 'delete',
                    fonction: 'BOUSUP',
                    iconButton: false,
                    successAction: () => {
                        vm.erdMultiOccurrence.fetchDataList();
                    }
                }
            ),
            new MenuDivider(),
            new MenuItemEcran(
                'LBL_TOLERANCE',
                mc1014Route.NAME,
                (rowData: any) => ({
                    tolcleintref: rowData.erdcleint,
                    vaeustent: 'ERD'
                }),
                {
                    fonction: 'BOUTOL',
                    icon: 'data_usage',
                    iconButton: false,
                    secondaire: true
                }
            ),
            new MenuItemEcran(
                'LBL_HISTO',
                ac2000Route.NAME,
                (rowData: any) => ({
                    erdcleint: rowData.erdcleint,
                    etrcleint: vm.monoOccurrence.data.etrcleint,
                }),
                {
                    fonction: 'BOUHIS',
                    icon: 'open_in_new'
                }
            )
        ]),
        colonnesFixesGauche: [
            { nom: 'edeitmdsc', largeur: 350 },
        ],
        colonnesVisibles: [
            { nom: 'edeitmnumcat', largeur: 140 },
            { nom: 'erditmprxneg', largeur: 126 },
            { nom: 'erditmmnt', largeur: 126 },
            { nom: 'erditmmntcon', largeur: 126 },
            { nom: 'erditmqte', largeur: 126 },
            { nom: 'erditmqtecon', largeur: 126 }
        ],
        colonnesCachees: [
            'erdcleint',
            'edecleint',
        ],
        formulaire: new Formulaire([
            new FormulaireItem('edecleint', {
                resourceParams: () => ({
                    etccleint: $stateParams.etccleint
                })
            }),
            new FormulaireItemSautDeLigne,
            new FormulaireItem('erditmprxneg'),
            new FormulaireItem('erditmmnt'),
            new FormulaireItem('erditmqte')
        ], { largeurDefaut: 33.33 })
    };

    vm.conMultiOccurrenceOptions = {
        bloc: 'con',
        colonnesFixesGauche: [
            { nom: 'dacnumdoc', largeur: 160, menu: docConsomme }
        ],
        colonnesVisibles: [
            { nom: 'tydcod', largeur: 140 },
            { nom: 'tyddsc', largeur: 220 },
            { nom: 'conmnt', largeur: 126 },
            { nom: 'docaffmnt01', largeur: 126 },
            { nom: 'etddsc', largeur: 180 },
            { nom: 'peccod', largeur: 100 },
            { nom: 'docaffdat01', largeur: 120 },
            { nom: 'docreqnom03', largeur: 180 },
            { nom: 'intnom', largeur: 180 }
        ],
        colonnesCachees: ['doccleintref', 'doccleint', 'daccleint', 'ecrcoddoc'],
    };

    function getForageItem(rowData: any): string {
        if (rowData.ecrcoddoc === 'AC0010-00-2') {
            return ac0010Route.NAME;
        }
        /* if (rowData.ecrcoddoc === 'IN0027-00-2') {
            return in0027Route.NAME;
        }*/
    }

    function getParamItem(rowData: any) {
        if (rowData.ecrcoddoc === 'AC0010-00-2') {
            return { id: rowData.doccleintref };
        }
        /*if (rowData.ecrcoddoc === 'IN0027-00-2') {
            return { id: rowData.doccleintref };
        }*/
    }

    function getParamItemSupprime(rowData: any) {
        return {
            erdcleint: rowData.erdcleint,
            etrcleint: vm.monoOccurrence.data.etrcleint,
        };
    }
}

